import React from 'react';
import styles from './button.module.scss';
import { IButton } from '@flexo/atoms';

export const Button: React.FC<IButton> = ({
  className,
  variant = 'primary',
  size = 'small',
  color = 'primary',
  label,
  icon,
  disabled,
  ...props
}) => {
  const typographyClass = size === 'micro' || size === 'small' ? 'detail' : 'heading4';

  return (
    <button
      type="button"
      className={`${styles.Button} ${styles[`Button--${variant}`]} ${
        styles[`Button--${size}`]
      } ${styles[`Button--${variant}--${color}`]} ${className} ${typographyClass}`}
      {...props}
      disabled={disabled}
    >
      <div>
        {icon && <span className={styles.Button__Icon}>{icon}</span>}
        <span>{label}</span>
      </div>
    </button>
  );
};

export default Button;
